import styled from 'styled-components';

export default styled.div`
  display: flex;
  align-items: flex-start;
  width: 100%;
  margin-bottom: 2rem;

  > :first-child {
    width: 12rem;
    margin-right: 2rem;
  }

  > :last-child {
    flex: 1;
    max-width: 35rem;
  }
`;
